import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  mainPagination: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '0.5rem',
    padding: '1rem',
    fontSize: '14px',
    marginTop: '0.5rem',
    borderRadius: '0.6rem',
  },
  pagination: {
    width: '100%',
  },
}));

export default useStyles;
